import { Meteor } from 'meteor/meteor';
import React from 'react';
import { moment } from 'moment';
import Moment from 'react-moment';
import { GroupBills } from '../../../collections/partners/group-bills';
import { GroupBillsPayments } from '../../../collections/partners/group-bills-payments';
import { HTTP } from 'meteor/http';
import { Tracker } from 'meteor/tracker';
import { Reactive } from '../../common/Reactive.mixin.js';

import {
  Icon,
  Table,
  Checkbox,
  Button,
  Modal,
  Progress,
  BPanel,
  FormControl,
  Col,
  Well,
  Link
} from '@sketchpixy/rubix';

@Reactive({
	subscriptions: ["group-bills"],
})
export class GroupBillModal extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      visible: this.props.visible,
      payments: this.props.payments
    };
  }

  componentWillReceiveProps({ visible }) {
    this.setState({
      visible: visible,
    });
  }

  goToView(event) {
    this.context.router.push('/reservations/' + event.target.id);
  }

  openPopUp(urlToOpen) {
    var popup_window=window.open(urlToOpen,"myWindow","toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, copyhistory=yes, width=400, height=400");
    try {
      popup_window.focus();
    }
    catch (e) {
      alert("Les fenêtes Pop-up sont bloquées ! Pour télécharger ce document, merci de les débloquer.");
    }
  }

  download(ref) {

    let groupBill = GroupBills.findOne(ref.target.id);

    let reservations = groupBill.getReservations().map((reservation) => {
      return {
        'flight': reservation.flight,
        'place': reservation.place,
        'createdAd': reservation.createdAd,
        'id_billet': reservation.id_billet,
        'price': reservation.price
      }
    });

    let data = {
      'groupBill': groupBill,
      'reservations': reservations,
      'partner': groupBill.getPartner()
    };

    //data.groupBill.month = moment(data.groupBill.month).format('MMM YYYY');

    HTTP.post('https://montgolfieres-pdf.amaia.at/scripts/pdf?type=groupFacture', {
      data
    }, (error, result) => {
      result = JSON.parse(result.content);
      this.openPopUp("https://montgolfieres-pdf.amaia.at/" + result.id + ".pdf");
    });

  }

  render() {
      return (
        <Modal show={this.state.visible} lg aria-labelledby="contained-modal-title-lg" onHide={::this.props.onHide}>
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-lg">Facture n°{this.props.bill.id_facture}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <BPanel header="Réservations associées">
            <Table striped bordered condensed hover responsive className="text-center">
              <thead>
                <tr>
                  <th>Billet</th>
                  <th>Nom/Prénom</th>
                  <th>Date</th>
                  <th>Montant</th>
                </tr>
              </thead>
              <tbody>
                {this.props.bill.getReservations().map((reservation) => (
                  <tr>
                    <td>{reservation.id_billet}</td>
                    <td>{reservation.searchName}</td>
                    <td><Moment format="DD/MM/YYYY à kk:mm">{reservation.createdAt}</Moment></td>
                    <td>{reservation.getPrice()}€</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </BPanel>

          <BPanel header="Etat de la facturation">

          <Table striped bordered responsive>
            <thead>
              <tr>
                <td>
                  {this.props.bill.getSolde() > 0 &&
                    <Button block bsStyle="danger">{this.props.bill.getSolde()} € restant</Button>
                  }
                  {this.props.bill.getSolde() <= 0 &&
                    <Button block bsStyle="success">{this.props.bill.getSolde()} € restant</Button>
                  }
                </td>
                <td>
                  <FormControl componentClass="select" type="select" ref="type">
                      <option value="Especes">Especes</option>
                      <option value="CB internet">CB internet</option>
                      <option value="CB">CB</option>
                      <option value="Chèque">Chèque</option>
                      <option value="Virement">Virement</option>
                      <option value="Autre">Autre</option>
                  </FormControl>
                </td>
                <td>
                  <FormControl placeholder="Montant" type="text" ref="montant"/>
                </td>
                <td>
                  <FormControl placeholder="Informations" type="text" ref="informations"/>
                </td>
                <td>
                  <Button bsStyle="primary" onClick={this.props.addPayment.bind(this)}>Ajouter</Button>
                </td>
              </tr>
              </thead>
            </Table>
            {this.props.payments && (this.props.payments.length > 0) &&
              <Table striped bordered responsive>
                <thead>
                  <tr>
                    <td>Date</td>
                    <td>Type</td>
                    <td>Montant</td>
                    <td>Informations</td>
                    <td>-</td>
                  </tr>
                </thead>
                <tbody>
                  {this.props.payments.map((payment) => (
                    <tr>
                      <td><Moment format="DD/MM/YYYY à kk:mm">{payment.createdAt}</Moment></td>
                      <td>{payment.type}</td>
                      <td>{payment.montant}€</td>
                      <td>{payment.informations}</td>
                      <td><center><Button bsStyle="danger" onClick={this.props.removePayment.bind(this)} value={payment._id}>X</Button></center></td>
                    </tr>
                  ))}
                </tbody>
              </Table>
          }

          {!this.props.payments &&
            <Progress active value={100} />
          }

          {this.props.payments && this.props.payments.length == 0 &&
            <Well>Il n'y a pas encore de paiement</Well>
          }


          </BPanel>


          <Button lg bsStyle='success' block id={this.props.bill._id} onClick={this.download.bind(this)}>Télécharger la facture</Button>
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="primary" onClick={::this.props.onHide}>Fermer</Button>
        </Modal.Footer>
        </Modal>
      );
  }
}

GroupBillModal.contextTypes = {
  router: React.PropTypes.object.isRequired
};



/** WEBPACK FOOTER **
 ** ./src/universal/components/partners/components/GroupBillModal.js
 **/